// extracted by mini-css-extract-plugin
export default {"mCard":"Vz-z","image":"Wz-z","imageNoBackground":"Xz-z","imageHasCategory":"Yz-z","fullWidth":"Zz-z"};